import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Hero from "../HeroSection/Hero";

const HeroesBar = ({ selectedIndex, setSelectedIndex, topUsers }) => {
  const [hoveredUserIndex, setHoveredUserIndex] = useState(null);
  const navigate = useNavigate();

  return (
    <div
      className="relative min-w-[64px] sm:w-[70px] md:w-[80px] lg:w-[90px]
      bg-zinc-800 rounded-[12px] sm:rounded-[16px] lg:rounded-[20px]
      p-2 sm:p-3 flex flex-col items-center justify-between
      transition-all duration-300 sm:hover:scale-105 sm:hover:shadow-2xl
      scrollbar-thin scrollbar-thumb-zinc-600 scrollbar-track-transparent"
      style={{ height: "288px" }}
    >
      {topUsers.map((user, i) => (
        <div
          key={user.id}
          className="relative"
          onMouseEnter={() => setHoveredUserIndex(i)}
          onMouseLeave={() => setHoveredUserIndex(null)}
        >
          {hoveredUserIndex === i && (
            <div
              className="absolute top-0 right-0 translate-x-1/3 -translate-y-1/3 z-50
              bg-white text-black text-[10px] sm:text-[11px] px-3 py-2
              rounded-xl border border-gray-300 shadow-md flex flex-col items-center
              whitespace-nowrap max-w-[140px] text-center"
            >
              <button
                onClick={() => navigate(`/${user.username}`)}
                className="text-cyan-600 font-semibold text-[11px] truncate hover:underline"
              >
                {user.firstName} {user.lastName}
              </button>
              <span className="text-xs font-semibold mt-1 text-gray-700">
                {user.totalPoints} pts
              </span>
            </div>
          )}

          <Hero
            selected={i === selectedIndex}
            onClick={() => setSelectedIndex(i)}
            total={topUsers.length}
            imageSrc={user.profileImage || "/default-avatar.png"}
          />
        </div>
      ))}
    </div>
  );
};

export default HeroesBar;
